import { useContext, useEffect, useRef } from 'react';

import { Paper, useTheme } from '@mui/material';

import MomentsUser from '../../components/MomentsUser';
import ForbiddenPage from '../../components/ForbiddenPage';
import Title from '../../components/Title';

import { getStyled } from './styles';

import { AuthContext } from '../../context/Auth/AuthContext';

const ChatMoments = () => {
  const theme = useTheme();
  const classes = getStyled(theme);

  const { user } = useContext(AuthContext);
  const paperRef = useRef(null);

  useEffect(() => {
    const paper = paperRef.current;
    if (!paper) return;

    const handleWheel = (e) => {
      const target = e.target;
      const card = target.closest('.card');

      if (card) {
        const hasVerticalScroll = card.scrollHeight > card.clientHeight;

        if (hasVerticalScroll) {
          return;
        }
      }

      e.preventDefault();
      paper.scrollLeft += e.deltaY;
    };

    paper.addEventListener('wheel', handleWheel, { passive: false });
    return () => paper.removeEventListener('wheel', handleWheel);
  }, []);

  return user.profile === 'user' && user.allowRealTime === 'disabled' ? (
    <ForbiddenPage />
  ) : (
    <div style={classes.mainHeader}>
      <div style={{ width: '90%', marginTop: 10 }}>
        <Title>Painel de Atendimentos</Title>

        <Paper sx={classes.mainPaper} variant='outlined' ref={paperRef}>
          <MomentsUser />
        </Paper>
      </div>
    </div>
  );
};

export default ChatMoments;
